// ZZ mark: two deliberately different colors — charcoal for the first Z, forest green for the second.
export function LogoMark({ className = "w-10 h-7" }) {
  return (
    <svg viewBox="0 0 48 34" className={className} fill="none" aria-hidden="true">
      <path d="M6 6 L22 6 L6 28 L22 28" stroke="#171A17" strokeWidth="4.2" strokeLinecap="square" />
      <path d="M26 6 L42 6 L26 28 L42 28" stroke="#5B8C5A" strokeWidth="4.2" strokeLinecap="square" />
    </svg>
  );
}


// Mountain wordmark: letters follow a ridge arc — outdoor identity, never flat.
export function MountainWordmark({ text = "ZEJZEN", className = "" }) {
  const arc = [0.42, 0.18, 0, 0, 0.18, 0.42];
  return (
    <span className={`inline-flex items-start ${className}`} style={{ paddingBottom: "0.5em" }} aria-label={text} data-testid="mountain-wordmark">
      {text.split("").map((ch, i) => (
        <span
          key={i}
          className="inline-block"
          style={{ transform: `translateY(${arc[i % arc.length]}em)` }}
        >
          {ch}
        </span>
      ))}
    </span>
  );
}

// Jagged ridge divider between folds — outdoor terrain feel.
export function RidgeLine({ fill = "var(--zjz-navy)", className = "w-full h-10 block" }) {
  return (
    <svg viewBox="0 0 1200 60" preserveAspectRatio="none" className={className} aria-hidden="true">
      <path d="M0 60 L0 42 L90 30 L180 44 L260 18 L340 40 L430 26 L520 46 L610 12 L700 38 L790 24 L880 44 L970 20 L1060 40 L1140 28 L1200 36 L1200 60 Z" fill={fill} />
    </svg>
  );
}
